import type { ClientAuthSummary } from '@/api/clients';
import { authRemainingHours, authUsedPct } from './clientHelpers';
import { cn } from '@/lib/cn';

/**
 * Auth progress bar for the client list — width tracks % of authorized hours
 * consumed. Color shifts warning → error as consumption crosses 50 / 80.
 */
export function AuthProgressBar({ auth }: { auth: ClientAuthSummary | null }) {
    if (!auth) {
        return <span className="text-xs text-text-subtle">No auth</span>;
    }
    const pct = authUsedPct(auth);
    const remaining = authRemainingHours(auth);
    const fillClass =
        pct >= 80 ? 'bg-error'
        : pct >= 50 ? 'bg-warning'
        : 'bg-accent-dark';
    return (
        <div className="flex items-center gap-2">
            <span className="text-xs tabular-nums w-8 text-right">{remaining}h</span>
            <div className="h-1.5 w-16 rounded-full bg-surface-muted overflow-hidden">
                <div
                    className={cn('h-full transition-[width]', fillClass)}
                    style={{ width: `${pct}%` }}
                />
            </div>
        </div>
    );
}
